import React, { Component } from 'react';
import Title from './Title';
import Typography from '@mui/material/Typography';
import { getIOTData } from '../API/zoekedAPI';


class DemoData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CPU: 4.5,
      Memory: 3.2      
    }
  }

  componentDidMount() {
    var dataCount = 0
   
    this.interval = setInterval(
        () => 
        getIOTData().then(data => {
              if (data.error) {
                console.log(data.error);
              } else {               
                dataCount = data.length - 1               
                this.setState({
                  // CPU: this.state.CPU + 2.3,
                  // Memory: this.state.Memory + 43.2,
                  // dataCount: data.length  
                  CPU: data[dataCount].cpu,
                  Memory : data[dataCount].memory        
                })
              }
            }), 1000
      );
  };

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }


  render() {

    return (
      <React.Fragment>
        <Title>PC data feed demo</Title>
        <Typography variant="h3" component="div" gutterBottom color="green">
          <b>CPU: {this.state.CPU.toFixed(1)}</b>         
        </Typography>
        <Typography variant="h3" component="div" gutterBottom color="black">
          <b>Memory: {this.state.Memory.toFixed(1)}</b>
        </Typography>
      </React.Fragment>
    );
  }
}

export default DemoData;
